/* eslint-disable react/no-array-index-key */

/* eslint-disable react/prop-types */
import React from 'react';

var Navigation = function Navigation(_ref) {
  var data = _ref.data,
      displaySubMenu = _ref.displaySubMenu,
      currentMenu = _ref.currentMenu,
      onClick = _ref.onClick,
      isDesktop = _ref.isDesktop,
      _onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut;
  var links = data || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, links.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "level1 ".concat(item.nestedLinks.length ? 'has-children' : 'no-children', "\n          ").concat(item.nestedLinks.length === 0 && window.location.href === item.link.href ? 'active' : ''),
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      className: "".concat(item.nestedLinks.length ? 'has-children' : 'no-children', " ").concat(item.nestedLinks.length && !isDesktop && currentMenu && currentMenu.href === item.link.href ? 'is-open' : '', "\n            ").concat(item.nestedLinks.length === 0 && window.location.href === item.link.href ? 'active' : '', "\n            ").concat(item.nestedLinks.length && window.location.href.indexOf("".concat(item.link.href)) > -1 ? 'level1-active' : ''),
      href: item.link.href,
      onClick: item.nestedLinks.length ? onClick : null,
      onMouseOver: item.nestedLinks.length ? _onMouseOver : null,
      onMouseOut: item.nestedLinks.length ? onMouseOut : null,
      onFocus: item.nestedLinks.length ? _onMouseOver : null,
      onBlur: item.nestedLinks.length ? onMouseOut : null
    }, item.link.content), displaySubMenu && currentMenu.href === item.link.href && /*#__PURE__*/React.createElement("ul", {
      style: {
        display: isDesktop ? 'flex' : 'block'
      },
      onMouseOver: function onMouseOver() {
        if (_onMouseOver) {
          _onMouseOver({
            target: {
              href: item.link.href
            }
          });
        }
      },
      onMouseOut: onMouseOut,
      onFocus: function onFocus() {
        if (_onMouseOver) {
          _onMouseOver({
            target: {
              href: item.link.href
            }
          });
        }
      },
      onBlur: onMouseOut
    }, !isDesktop && item.nestedLinks.length && /*#__PURE__*/React.createElement("li", {
      className: "level2 level3"
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link.href,
      className: "".concat(window.location.href === item.link.href ? 'active' : '')
    }, "Introduction")), item.nestedLinks.map(function (level2, indx) {
      return /*#__PURE__*/React.createElement("li", {
        className: "level2",
        key: indx
      }, /*#__PURE__*/React.createElement("h3", null, level2.link.content), /*#__PURE__*/React.createElement("ul", null, level2.nestedLinks.map(function (level3, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "level3 ",
          key: i
        }, /*#__PURE__*/React.createElement("a", {
          className: " ".concat(window.location.href === level3.link.href ? 'active' : ''),
          href: level3.link.href
        }, level3.link.content));
      })));
    })));
  }));
};

export default Navigation;